import { RootState } from '../reducers'

export const getIsLoading = (state: RootState) =>
  state.openIddictApplication.isLoading
export const getIsConfirmLoading = (state: RootState) =>
  state.openIddictApplication.isConfirmLoading
export const getIsLogoSaving = (state: RootState) =>
  state.openIddictApplication.isLogoSaving
export const getApplications = (state: RootState) =>
  state.openIddictApplication.applications
export const getApplicationSelected = (state: RootState) =>
  state.openIddictApplication.applicationSelected
export const getApplicationCreateDraft = (state: RootState) =>
  state.openIddictApplication.applicationCreateDraft
export const getModalVisibility = (name: string) => (state: RootState) =>
  state.openIddictApplication.modalVisibility[name]?.visible || false
